<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img :src="user.profile_picture" class="img-avatar" :alt="user.name" />
      <div class="username mr-25 pull-right text-left">
        <p>{{user.name}}</p>
        <span>{{user.roles}}</span>
      </div>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Akun</strong>
      </b-dropdown-header>
      <a role="menuitem" href="#/change-profile" class="dropdown-item"><i class="fa fa-user" /> Ubah Profil</a>
      <a role="menuitem" href="#/change-password" class="dropdown-item"><i class="fa fa-key" /> Ubah Password</a>
      <a role="menuitem" href="#" v-on:click="logout" class="dropdown-item"><i class="fa fa-sign-out" /> Keluar</a>
    </template>
  </AppHeaderDropdown>
</template>

<script>
  import {
    HeaderDropdown as AppHeaderDropdown
  } from '@coreui/vue'
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
      AppHeaderDropdown
    },
    data: function () {
      return {
        user: {}
      }
    },
    // computed: {
    //   ...mapGetters({
    //     user: 'user'
    //   })
    // },
    mounted(){
      this.user = JSON.parse(localStorage.getItem('user'));
    },
    methods: {
      logout() {
        const _ = this;
        _.$axios.post('/Authentication/logout', null , { params: { email: _.user.email} } );
        _.$store.dispatch('logout')
        _.$router.push('/home');
      }
    }
  }
</script>